import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";

const TemporaryEmployees = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold mb-8 text-gray-800">
          Temporary Employees
        </h1>
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="flex items-center mb-4">
            <Clock className="w-12 h-12 text-red-500 mr-4" />
            <p className="text-xl text-gray-700">
              Short-term staffing solutions for your immediate needs.
            </p>
          </div>
          <p className="text-gray-600 mb-4">
            Our Temporary Employees service provides flexible staffing solutions
            to help you manage workload fluctuations, special projects, or
            temporary absences. We offer skilled professionals ready to
            contribute immediately to your team.
          </p>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            How It Works
          </h2>
          <ol className="list-decimal list-inside mb-6 text-gray-700">
            <li className="mb-2">
              You inform us about your temporary staffing needs
            </li>
            <li className="mb-2">
              We quickly source and vet qualified candidates
            </li>
            <li className="mb-2">
              Temporary employees start working on your project
            </li>
            <li className="mb-2">We handle payroll and administrative tasks</li>
            <li>You focus on your core business activities</li>
          </ol>
          <Link
            to="/contact"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center text-lg font-semibold"
          >
            Get Started <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </main>
    </div>
  );
};

export default TemporaryEmployees;
